/**
 * API base URL (no trailing slash).
 * Production (Express serves SPA + API): leave empty → same-origin `/api`, `/uploads`.
 * Dev: leave empty → Vite proxy forwards `/api` and `/uploads` to port 8789.
 * Override only if you split frontend/API again: set `VITE_API_URL`.
 */
export const API_BASE = import.meta.env.VITE_API_URL || ''

/** Resolve upload/asset paths; same-origin uses relative URLs when API_BASE is empty. */
export function apiAssetUrl(assetPath: string | null | undefined): string {
  if (!assetPath) return ''
  if (assetPath.startsWith('http://') || assetPath.startsWith('https://')) return assetPath
  return assetPath.startsWith('/') ? `${API_BASE}${assetPath}` : `${API_BASE}/${assetPath}`
}
